import React, { useState, useEffect, useRef, useCallback } from 'react';

import { 
  Character, 
} from "@dndModels";

import API from "@utilities/smart_api";
import CommonUtilities from "@utilities/common_utilities";
import DataUtilities from "@dndUtilities/data_utilities";

import LinkButton from '@components/input/buttons/icon_buttons/LinkButton';
import SaveButton from '@components/input/buttons/icon_buttons/SaveButton';
import RefreshButton from '@components/input/buttons/icon_buttons/RefreshButton';

interface Props {
  char: Character;
}

const time = 30;
// const save_time = 180;

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();
const data_util = DataUtilities.getInstance();

// TODO: Make it keep previous versions
// And make it so if on load it finds missing things
// it disables auto-save, checks the last version, 
// and suggests reverting. 
// If the last one is missing things as well, 
// check the one before that. Keep 5 previous versions.

export default function CharacterSaveTools({
  char,
}: Props) {
  const [fetched, setFetched] = useState(false);
  const [seconds, setSeconds] = useState(0);
  const [go, setGo] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [saving, setSaving] = useState(false);
  const [changed, setChanged] = useState(false);
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (!fetched) {
      setFetched(true);
    }
  }, [fetched, char]);

  const characterChanged = useCallback(() => {
    // console.log("characterChanged()");
    if (!go && !saving && char.changed_since_saved) {
      setSeconds(time);
      setGo(true);
    }
  }, [go, saving, char]);

  useEffect(() => {
    if (changed) {
      setChanged(false);
      setTimeout(() => {
        characterChanged();
      }, 100);
    }
  }, [changed, setChanged]);

  const saveCharacter = useCallback( async (save_to_db: boolean) => {
    console.log(save_to_db);
    if (!processing) {
      setProcessing(true);
      setSeconds(0);
      setSaving(true);
      // Until everything has loaded the character may have only been built from 
      // part of the data, so don't save until it's been rebuilt with all of it.
      await data_util.core_data_loading;
      char.last_saved = common_util.get_time_number();
      await api.updateCharacter(char, ["all"]);
      setSaving(false);
      setGo(false);
      setProcessing(false);
    }
  }, [char, processing]);

  useEffect(() => {
    if (go) {
      if (seconds > 0) {
        setTimeout(() => {
          if (go) {
            setSeconds(seconds - 1);
          } else {
            setSeconds(0);
          }
        }, 1000);
      } else {
        setTimeout(() => {
          saveCharacter(false);
        }, 100);
      }
    }
  }, [go, seconds, char, saveCharacter]);

  const charChanged = useCallback(() => { 
    console.log("Char Save Tools - Changed");
    setTimeout(() => {
      char.last_changed = common_util.get_time_number();
      setChanged(true);
    }, 100);
  }, []);

  useEffect(() => {
    console.log("Char Save Tools");
    char.subscription_holder.subscribe("Character", mounted, charChanged);
  }, [char, charChanged]);

  // const secondsToTimeString = (s: number) => {
  //   const mins = Math.floor(s/60);
  //   const secs = s % 60;
  //   return mins > 0 ? (secs > 9 ? `${mins}:${secs}` : `${mins}:0${secs}`) : `${secs}`;
  // }
  
  // console.log(character.last_changed);
  // console.log(character.saved);
  // console.log(character.changed_since_saved);
  // console.log(character.last_saved);
  // console.log(character.changed_since_saved);

  return (
    <div>
      { api.online ? 
        <>
          <div style={{ float: "left" }}>
            <RefreshButton label="Reload from DB" 
              disabled={processing || saving}
              onClick={() => {
                setProcessing(true);
                setGo(false);
                setSeconds(0);
                const id = char._id;
                // debugger;
                api.removeCharacterCookies(id);
                char.subscription_holder.reload();
              }}
            />
          </div>
        </>
      :
        <>
          <div style={{ float: "left" }}>
            <SaveButton label="DB Unavailable" 
              disabled
              onClick={() => {}}
            />
          </div>
        </>
      }
      <div style={{ float: "left" }}>
        <SaveButton label={ saving ? "Saving" : (seconds === 0 || !go ? "Saved" : `Auto save in ${seconds}`) } 
          disabled={processing || !go}
          onClick={() => {
            saveCharacter(false);
          }}
        />
      </div>
      <div style={{ float: "left" }}>
        <LinkButton 
          label={ char.changed_since_saved ? "Printable PDF (Save First)" : "Printable PDF"}
          disabled={processing || char.changed_since_saved}
          to={`/character/printable/${char._id}`} 
          target="_blank" 
        />
      </div>
    </div>
  );
}
